import React from 'react';
import { Field } from '../../ui/Field';
import { TextInput } from '../../ui/TextControl';
import { ChoiceChip } from '../../ui/ChoiceChip';
import { asDraft } from '../../../types/registration';
import { PROGRAM_TYPES } from '../../../data/registration';
import type { QuestionProps } from './types';
export function ProgramsQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  function toggleProgram(program: string) {
    const next = draft.programs.includes(program) ? draft.programs.filter(item => item !== program) : [...draft.programs, program];
    update({
      programs: next
    });
  }
  return <div className="flex flex-col gap-6" data-id="element-462" data-mp="20qumjtsm8nfn">
      <div className="flex flex-wrap gap-2" role="group" aria-label="What you were part of" data-id="element-463" data-mp="25riovbmaoqp6">
        {PROGRAM_TYPES.map(program => <ChoiceChip key={program} checked={draft.programs.includes(program)} onChange={() => toggleProgram(program)} data-id="element-464" data-mp="3c6jb2plipuik">
            {program}
          </ChoiceChip>)}
      </div>

      <Field name="roleNote" label="Anything an old friend would recognize you by" hint="Optional. A line is plenty." data-id="element-465" data-mp="1x8t6e6etrqfp">
        <TextInput id="roleNote" name="roleNote" placeholder="Tuesday night group, back room" value={draft.roleNote} onChange={event => update({
        roleNote: event.target.value
      })} data-id="element-466" data-mp="1o84upicwm25z" />
      </Field>
    </div>;
}